import React, { createContext, useState, useEffect, useContext } from 'react';

const DEFAULT_EVENT_ID = process.env.REACT_APP_EVENT_ID || "35";

const FeaturedEventContext = createContext({
  featuredEventId: DEFAULT_EVENT_ID,
  setFeaturedEventId: () => {},
  featuredEventDate: "",
  setFeaturedEventDate: () => {},
  featuredEventTime: "",
  setFeaturedEventTime: () => {},
});

export const FeaturedEventProvider = ({ children }) => {
  const getInitialFeaturedEventId = () => {
    const storedId = localStorage.getItem('featuredEventId');
    if (storedId) {
      try {
        const parsed = JSON.parse(storedId);
        if (parsed === null || parsed === "null") {
          return DEFAULT_EVENT_ID;
        }
        return parsed;
      } catch (error) {
        return DEFAULT_EVENT_ID;
      }
    }
    return DEFAULT_EVENT_ID;
  };

  const getInitialFeaturedEventDate = () => {
    return localStorage.getItem('featuredEventDate') || "";
  };

  const getInitialFeaturedEventTime = () => {
    return localStorage.getItem('featuredEventTime') || "";
  };

  const [featuredEventId, setFeaturedEventId] = useState(getInitialFeaturedEventId);
  const [featuredEventDate, setFeaturedEventDate] = useState(getInitialFeaturedEventDate);
  const [featuredEventTime, setFeaturedEventTime] = useState(getInitialFeaturedEventTime);

  useEffect(() => {
    localStorage.setItem('featuredEventId', JSON.stringify(featuredEventId));
  }, [featuredEventId]);

  useEffect(() => {
    localStorage.setItem('featuredEventDate', featuredEventDate);
  }, [featuredEventDate]);

  useEffect(() => {
    localStorage.setItem('featuredEventTime', featuredEventTime);
  }, [featuredEventTime]);

  return (
    <FeaturedEventContext.Provider
      value={{
        featuredEventId,
        setFeaturedEventId,
        featuredEventDate,
        setFeaturedEventDate,
        featuredEventTime,
        setFeaturedEventTime
      }}
    >
      {children}
    </FeaturedEventContext.Provider>
  );
};

export function useFeaturedEvent() {
  return useContext(FeaturedEventContext);
}

export default FeaturedEventContext;
